module.exports = __webpack_public_path__ + "img/MilitaryTechBackgroundC05_ua.540b009b.webp";